import type { Transition } from "framer-motion";

/**
 * Shared framer-motion vocabulary — one config per motion ROLE, so surfaces
 * that play the same role move identically (before this, modals shipped with
 * three different springs and backdrops with three durations).
 *
 * Pick by role, not by taste:
 *  - FADE_BACKDROP  — modal/overlay backdrop opacity fades
 *  - EASE_OUT_PANEL — content panels sliding/fading into place (tween)
 *  - EASE_OUT_NOTICE— soft notices (nudges, consent bars)
 *  - SPRING_MODAL   — dialog/popup panel pop
 *  - SPRING_PILL    — layoutId tab/toggle indicator slides
 *  - SPRING_CARD    — card hover/press scale
 *  - SPRING_SHEET   — side sheets (account sidebar)
 *  - EASE_OUT_REVEAL— scroll-in reveals of sections
 */
export const FADE_BACKDROP: Transition = { duration: 0.2 };
export const EASE_OUT_PANEL: Transition = { duration: 0.22, ease: "easeOut" };
export const EASE_OUT_NOTICE: Transition = { duration: 0.25, ease: "easeOut" };
export const SPRING_MODAL: Transition = { type: "spring", stiffness: 320, damping: 28 };
export const SPRING_PILL: Transition = { type: "spring", stiffness: 420, damping: 34 };
export const SPRING_CARD: Transition = { type: "spring", stiffness: 400, damping: 30 };
export const SPRING_SHEET: Transition = { type: "spring", stiffness: 380, damping: 40 };
/** Scroll-in reveals of sections and list items. */
export const EASE_OUT_REVEAL: Transition = { duration: 0.5, ease: [0.22, 1, 0.36, 1] };
